const getInitials = (name?: string) => {
  if (!name) {
    return "";
  }
  const names = name.trim().split(/\s+/);
  if (names.length === 1) {
    return names[0].substring(0, 2).toUpperCase();
  }
  return names.reduce((acc: string, word: string) => {
    return `${acc}${word[0]?.toUpperCase() || ""}`;
  }, "");
};

export default getInitials;
